exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".day-configurator-body[data-v-33f0f7cb] {\n  height: calc(100vh - 65px);\n  height: calc(var(--vh, 1vh) * 100 - 65px);\n}", ""]);

// exports
